import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [{
      path: '/',
      meta: {
        title: '知展360-国外展会名录&国外采购商数据'
      },
      component: () =>
        import('./components/layout/BaseLayout.vue'),
      children: [{
          path: '',
          name: 'index',
          component: (() => import('@/views/Index.zz360'))
        }, {
          path: '/product',
          name: 'product',
          component: () =>
            import('@/views/Product')
        }, {
          path: '/register',
          name: 'register',
          component: () =>
            import('@/views/Register')
        },{
          path: '/updatelogs',
          name: 'updatelogs',
          component: () =>
            import('@/views/UpdateLogs')
        }, {
          path: '/about',
          name: 'about',
          meta: {
            type: 'about',
            title: '关于我们 - 知展360'
          },
          component: () =>
            import('@/views/About')
        }, {
          path: '/protocol',
          name: 'protocol',
          meta: {
            type: 'protocol',
            title: '用户注册协议 - 知展360'
          },
          component: () =>
            import('@/views/About')
        },
        {
          name: 'notfound',
          path: '/404',
          component: () => import('./views/404.vue')
        },
      ]
    },

    {
      path: '/account',
      name: 'account',
      redirect: '/account/dashboard',
      meta: {
        mustLogin: true,
        title: '会员中心-知展360',
      },
      component: () =>
        import('./components/layout/MainLayout.vue'),
      children: [{
          path: '/account/dashboard',
          name: 'dashboard',
          meta: {
            menu: 'dashboard'
          },
          component: () =>
            import('@/views/account/Dashboard')
        }, {
          path: '/account/recharge',
          name: 'recharge',
          meta: {
            menu: 'dashboard'
          },
          component: () =>
            import('@/views/account/Recharge')
        },
        {
          path: '/account/keyperson/:pageNo([1-9]\\d*)?',
          name: 'keyperson',
          meta: {
            menu: 'keyperson'
          },
          component: () =>
            import('@/views/account/KeyPerson')
        },
        {
          path: '/account/keypersondetail/:id([1-9]\\d*)?',
          name: 'keypersondetail',
          meta: {
            menu: 'keyperson'
          },
          component: () =>
            import('@/views/account/KeyPersionDetail')
        },
        {
          path: '/account/buyer',
          name: 'buyer',
          meta: {
            menu: 'buyer'
          },
          component: () =>
            import('@/views/account/Purchaser')
        },
        {
          path: '/account/exhibitor',
          name: 'exhibitor',
          meta: {
            menu: 'exhibitor'
          },
          component: () =>
            import('@/views/account/Purchaser')
        },
        {
          path: '/account/findlog',
          name: 'findlog',
          meta: {
            menu: 'findlog'
          },
          component: () =>
            import('@/views/account/FindLog')
        },
        {
          path: '/account/profile',
          name: 'profile',
          meta: {
            menu: 'profile'
          },
          component: () =>
            import('@/views/account/Profile')
        },
        {
          path: '/account/related',
          name: 'related',
          meta: {
            menu: 'related'
          },
          component: () =>
            import('@/views/account/related')
        },
        {
          path: '/account/notify',
          name: 'notify',
          meta: {
            menu: 'notify'
          },
          component: () =>
            import('@/views/account/Notify')
        },
        {
          path: '/account/social',
          name: 'social',
          meta: {
            menu: 'social'
          },
          component: () =>
            import('@/views/account/Social')
        },
        {
          path: '/account/notify2',
          name: 'notify2',
          meta: {
            menu: 'notify2'
          },
          component: () =>
            import('@/views/account/Notify2')
        }
      ]
    },


    {
      path: '/emailfinder',
      meta: {
        title: '国际买家关键人定位-知展360'
      },
      redirect: '/emailfinder',
      component: () =>
        import('./components/layout/BaseLayout.vue'),
      children: [{
          path: '/emailfinder/',
          name: 'emailfinder',
          component: () =>
            import('./views/emailfinder/Home.vue')
        },
        {
          path: '/emailfinder/search',
          name: 'search',
          component: () =>
            import('./views/emailfinder/Search.vue')
        }
      ]
    },
    ...[
      {
        path: '/buyerfinder',
        meta: {
          title: ''
        },
        name: 'buyerfinder',
        redirect: '/buyerfinder/',
        component: () =>
          import('./components/layout/BaseLayout.vue'),
        children: [{
            meta: {
              keepAlive: true
            },
            name: 'buyerlist',
            path: '/buyerfinder/:pageNo([1-9]\\d*)?',
            component: () =>
              import('./views/buyerfinder/List.vue')
          },
          {
            path: '/buyerfinder/detail/:pid([1-9]\\d*)?',
            name: 'buyerdetail',
            component: () =>
              import('./views/buyerfinder/Detail.vue')
          },
          {
            path: '/buyerfinder/exhibitors/:soid([1-9]\\d*)?',
            name: 'exhibitors',
            component: () =>
              import('./views/buyerfinder/Exhibitors.vue')
          }
        ]
      },
    ].filter(x => x),
    {
      path: '*', // 此处需特别注意至于最底部
      redirect: '/404'
    },
  ]
})

var vm = null;
router.afterEach((to) => {
  to.matched.slice(0).reverse().some(r => {
    return r.meta && r.meta.title && (document.title = r.meta.title, true);
  })
});
router.beforeEach((to, from, next) => {
  var _this = router.app;
  if (!_this.$store.state.accountInfo) {

    new Promise((resolve) => {

      _this.$http
        .post("/zzAccountInfo", {
          token: _this.$cookies.get("access-token") || ""
        })
        .then(res => {
          if (!res.error) {
            _this.$store.dispatch('SetAccountInfo', res.data);
            resolve(true);
          } else {
            resolve(false);
          }
        })
        .catch((e) => {
          resolve(false);
        });

    }).then(res => {
      if (to.matched.some(t => t.meta.mustLogin)) {
        if (res) {
          next()
        } else {
          next('/')
        }
      } else {
        next();
      }
    })
  } else {
    next();
  }
});

export default router